<template>
    <a-input
        :value="value"
        @input="onInput"
        style="width:100%"
        :disabled="disabled"
    >
        <span slot="addonBefore" style="width: 20%">
            <i :class="localeClass(locale)" />
        </span>

        <span slot="addonAfter">
            <i class="fa fa-check" v-if="isValid" />
            <i class="fa fa-times" v-if="!isValid" />
        </span>
    </a-input>
</template>
<script>
// import restcountries from 'restcountries-js'
// import uniqBy from 'lodash/uniqBy'

import {
    parsePhoneNumberFromString,
    // parsePhoneNumber,
    // AsYouType,
} from 'libphonenumber-js'

export default {
    props: {
        value: {
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        defaultLocale: {
            type: String,
            default: '',
        },
    },

    methods: {
        localeClass(locale) {
            return 'flag-icon flag-icon-' + locale.toLowerCase()
        },

        onInput(e) {
            let value = e.target.value.trim()

            console.log(e, this.value)

            // this.$forceUpdate()

            // let num = new AsYouType(this.locale).input(value)

            this.$emit('input', value)
        },

        getNumber(val) {
            try {
                return (
                    parsePhoneNumberFromString(this.value) || {
                        number: val,
                    }
                )
            } catch (err) {
                return false
            }
        },
    },

    computed: {
        locale() {
            try {
                return this.phonenumber.country || this.defaultLocale
            } catch (err) {
                return this.defaultLocale
            }
        },

        isValid() {
            try {
                return this.phonenumber.isValid()
            } catch (err) {
                return false
            }
        },

        phonenumber() {
            return this.getNumber(this.value)
        },
    },
}
</script>
